module.exports = __webpack_public_path__ + "img/lorena-silva.6df040e5.jpg";